import React from 'react';
import PropTypes from 'prop-types';
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Button,
  ButtonGroup,
  Card,
  CardContent,
  CardHeader,
  FormControl,
  Grid,
  IconButton,
  Checkbox,
  TextField,
} from '@mui/material';
import { Title, Text, ButtonOptions } from 'shared/components';
import {
  Help as HelpIcon,
  ExpandMore as ExpandMoreIcon,
  CheckBox as CheckBoxIcon,
  CheckBoxOutlineBlank as CheckBoxOutlineBlankIcon,
} from '@mui/icons-material';
import useStyles from './styles';
import { getHelpText } from '../../utils/cube/constants';
import Autocomplete from '@mui/lab/Autocomplete';

const CardSettingsBeneficiaries = ({
  OPTIONS,
  form,
  beneficiaries,
  getSegmentsOptions,
  handleChangeForm
}) => {
  const classes = useStyles();
  const checkedIcon = <CheckBoxIcon fontSize="small" />;
  const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
  const benficieriesValues = (form.beneficiaries.length > 0) ? 
    form.beneficiaries.map(key => beneficiaries.filter(item => item.id === parseInt(key, 10))[0].name) :
    form.beneficiaries;
  let beneficiariesOption = beneficiaries.map(item => item.name);
  if (form.beneficiaries && form.beneficiaries.length > 0 && form.beneficiaries.includes(0)) {
    beneficiariesOption = beneficiariesOption.slice(0, 1);
  }
  return (
    <>
      <TextField
        label="Display name (optional)"
        value={form.customName}
        onChange={e => handleChangeForm('customName', e.target.value)}
        variant="outlined"
        size="small"
        fullWidth
        inputProps={{ style: { fontSize: 14 } }}
      />
      <Accordion className={classes.expansionPanel}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1a-content"
          id="panel1a-header"
          className={classes.expansionPanelSummary}
        >
          <Title className={classes.titleSubCard}>Beneficiaries</Title>
        </AccordionSummary>
        <AccordionDetails className={classes.expansionPanelDetails}>
          <Card className={classes.rootSubCard}>
            <CardHeader
              action={
                <IconButton aria-label="help">
                  <HelpIcon />
                </IconButton>
              }
              subheader={
                <Text className={classes.subHeaderSubCard}>
                  Which beneficiary types do you want to see data for?
                </Text>
              }
            />
            <CardContent className={classes.cardContent}>
              <FormControl className={classes.selectContainer}>
                <Autocomplete
                  multiple
                  id="checkboxes-tags-demo"
                  size="small"
                  options={beneficiariesOption}
                  value={benficieriesValues}
                  onChange={(_, values) => {
                    let selected = values.map(name => beneficiaries.filter(item => item.name === name)[0].id);
                    if (selected.includes(0)) selected = [0];
                    handleChangeForm('beneficiaries', selected);
                  }}
                  disableCloseOnSelect
                  getOptionLabel={option => option}
                  renderOption={(option, { selected }) => (
                    <>
                      <Checkbox
                        icon={icon}
                        checkedIcon={checkedIcon}
                  
                        checked={selected}
                      />
                      <Text
                        variant="body1"
                       
                      >
                        {option}
                      </Text>
                    </>
                  )}
                  renderInput={params => (
                    <TextField
                      {...params}
                      variant="outlined"
                      label={`Beneficiaries -  ${form.beneficiaries.length} selected`}
                    />
                  )}
                />
              </FormControl>
              <Grid
                container
                direction="row"
                justify="flex-start"
                alignItems="center"
                style={{ textAlign: 'left' }}
              >
                <Grid item xs={3} className={classes.gutterBottomCardRow}>
                  <ButtonGroup
                    orientation="vertical"
                    color="primary"
                    aria-label="vertical contained primary button group"
                    variant="contained"
                  >
                    <Button
                      onClick={() => handleChangeForm('switch', 'Any')}
                      className={
                        form.switch === 'Any'
                          ? classes.btnVrtOn
                          : classes.btnVrt
                      }
                    >
                      Individually
                    </Button>
                    <Button
                      onClick={() => handleChangeForm('switch', '')}
                      className={
                        form.switch === '' ? classes.btnVrtOn : classes.btnVrt
                      }
                    >
                      Combined
                    </Button>
                  </ButtonGroup>
                </Grid>
                <Grid item xs={9} className={classes.gutterBottomCardRow}>
                  <div
                    className={classes.wrapperTextButtonSubCard}
                    style={{ paddingBottom: 5 }}
                  >
                    <Text
                      variant="caption"
                      display="block"
                      className={classes.textButtonSubCard}
                    >
                      Data displayed by each beneficiary type selected (in
                      separate rows)
                    </Text>
                  </div>
                  <div className={classes.wrapperTextButtonSubCard}>
                    <Text
                      variant="caption"
                      display="block"
                      className={classes.textButtonSubCard}
                    >
                      Data only from reports serving ALL selected beneficiaries
                      (in one row)
                    </Text>
                  </div>
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </AccordionDetails>
      </Accordion>

      <Accordion className={classes.expansionPanel}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1a-content"
          id="panel1a-header"
          className={classes.expansionPanelSummary}
        >
          <Title className={classes.titleSubCard}>Metric</Title>
        </AccordionSummary>
        <AccordionDetails className={classes.expansionPanelDetails}>
          <Card className={classes.rootSubCard}>
            <CardHeader
              action={
                <IconButton aria-label="help">
                  <HelpIcon />
                </IconButton>
              }
              subheader={
                <Text className={classes.subHeaderSubCard}>
                  What data do you want to display for the beneficiaries you
                  selected?
                </Text>
              }
            />
            <CardContent>
              <Grid
                container
                direction="row"
                justify="flex-start"
                alignItems="center"
                style={{ textAlign: 'left' }}
              >
                <Grid item xs={12} className={classes.gutterBottomCardRow}>
                  <ButtonOptions
                    options={OPTIONS.METRICS}
                    onChange={value => handleChangeForm('metric', value)}
                    value={form.metric}
                    optionsTextHelper={getHelpText}
                  />
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </AccordionDetails>
      </Accordion>

      <Accordion className={classes.expansionPanel}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1a-content"
          id="panel1a-header"
          className={classes.expansionPanelSummary}
        >
          <Title className={classes.titleSubCard}>Segment</Title>
        </AccordionSummary>
        <AccordionDetails className={classes.expansionPanelDetails}>
          <Card className={classes.rootSubCard}>
            <CardHeader
              action={
                <IconButton aria-label="help">
                  <HelpIcon />
                </IconButton>
              }
              subheader={
                <Text className={classes.subHeaderSubCard}>
                  How do you want to group the data? (Calculations will be made
                  separately for each group displayed side-by-side)
                </Text>
              }
            />
            <CardContent>
              <Grid
                container
                direction="row"
                justify="flex-start"
                alignItems="center"
                style={{ textAlign: 'left' }}
              >
                <Grid item xs={12} className={classes.gutterBottomCardRow}>
                  <ButtonOptions
                    titleMarging={20}
                    options={getSegmentsOptions()}
                    onChange={value => handleChangeForm('segment', value)}
                    value={form.segment}
                    optionsTextHelper={getHelpText}
                  />
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </AccordionDetails>
      </Accordion>

      <Accordion className={classes.expansionPanel}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1a-content"
          id="panel1a-header"
          className={classes.expansionPanelSummary}
        >
          <Text className={classes.titleSubCard}>Filters</Text>
        </AccordionSummary>
        <AccordionDetails className={classes.expansionPanelDetails}>
          <Card className={classes.rootSubCard}>
            <CardHeader
              action={
                <IconButton aria-label="help">
                  <HelpIcon />
                </IconButton>
              }
              subheader={
                <Title className={classes.subHeaderSubCard}>
                  What data do you want to include?
                </Title>
              }
            />
            <CardContent className={classes.cardContent}>
              <Grid
                container
                direction="row"
                justify="flex-start"
                alignItems="center"
                style={{ textAlign: 'left' }}
              >
                <Grid item xs={6} className={[classes.gutterBottomCardRow, classes.flexAuto]}>
                  <ButtonOptions
                    titleMarging={20}
                    optionsObject={OPTIONS.YEAR}
                    options={OPTIONS.FILTER}
                    onChange={value => handleChangeForm('filter', value)}
                    float
                    value={form.filter}
                    multiple
                    optionsTextHelper={getHelpText}
                  />
                </Grid>
                <Grid item xs={6} className={classes.gutterBottomCardRow}>
                  <ButtonOptions
                    titleMarging={20}
                    options={OPTIONS.STATUS}
                    onChange={value => handleChangeForm('status', value)}
                    float
                    value={form.status}
                    optionsTextHelper={getHelpText}
                  />
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </AccordionDetails>
      </Accordion>

      <Accordion className={classes.expansionPanel}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1a-content"
          id="panel1a-header"
          className={classes.expansionPanelSummary}
        >
          <Title className={classes.titleSubCard}>Comparison</Title>
        </AccordionSummary>
        <AccordionDetails className={classes.expansionPanelDetails}>
          <Card className={classes.rootSubCard}>
            <CardHeader
              action={
                <IconButton aria-label="help">
                  <HelpIcon />
                </IconButton>
              }
              subheader={
                <Text className={classes.subHeaderSubCard}>
                  What do you want to compare your results with?
                </Text>
              }
            />
            <CardContent className={classes.cardContent}>
              <Grid
                container
                direction="row"
                justify="flex-start"
                alignItems="center"
                style={{ textAlign: 'left' }}
              >
                <Grid item xs={12} className={classes.gutterBottomCardRow}>
                  <ButtonOptions
                    titleMarging={20}
                    options={OPTIONS.COMPARE}
                    optionsObject={OPTIONS.COMPARISONYEAR}
                    onChange={value =>
                      handleChangeForm('comparisonyear', value)
                    }
                    float
                    value={form.comparisonyear}
                    optionsTextHelper={getHelpText}
                  />
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </AccordionDetails>
      </Accordion>
    </>
  );
};

CardSettingsBeneficiaries.propTypes = {
  OPTIONS: PropTypes.object,
  form: PropTypes.object,
  beneficiaries: PropTypes.array,
  getSegmentsOptions: PropTypes.func,
  handleChangeForm: PropTypes.func,
};

export default CardSettingsBeneficiaries;
